/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';


export interface IReading {
    nivel_alerta?: string;
    responsavel_leitura?: string;
    nome?: string;
    utm_ew?: number;
    utm_ns?: number;
    utm_zone?: number;
    tipo_instrumento?: string;
    id_barragem?: string;
    id_instrumento?: string;
    status?: boolean;
    alerta_enviado?: boolean;
    latitude?: number;
    longitude?: number;
    // data_leitura?: Date | string;
    data_leitura?: string;
    sem_leitura?: boolean;
    condicao_leitura?: string;
    profundidade?: string;
    cota?: string;
    coordenada_y?: string;
    coordenada_x?: string;
    elevacao_z?: string;
    deslocamento_x?: string;
    deslocamento_y?: string;
    deslocamento_z?: string;
    vetor_deslocamento_xy?: string;
    vetor_deslocamento_xz?: string;
    vetor_deslocamento_yz?: string;
    file?: string;
    leitura_diaria?: string;
    nivel_agua?: string;
    vazao?: string;
    borda_livre?: string;
    responsavel?: string;
    angulo?: string;
    uuid?: string;
    comentario?: string;
    ultima_leitura?: IReading;
}

export interface IReadings {
    desl_abs_x: any;
    desl_rel_x: any;
    nivel_alerta?: string;
    desl_abs_y: any;
    desl_rel_y: any;
    desl_abs_z: any;
    desl_rel_z: any;
    comentarios: string;
    condicao_leitura: string;
    cota: string;
    data_leitura: string;
    nome: string;
    vazao: number;
    profundidade_pio: string;
    uuid: string;
    angulo: number;
    leitura_diaria: number;
    borda_livre: number;
    deslocamento: number;
}

// Interface para representar um instrumento
export interface IReadingsInstruments {
    // [x: string]: any;
    leituras: IReadings[];
    nivel_alerta?: string;
    nome: string;
    responsavel_leitura?: string; 
    tipo_instrumento: string;
    uuid: string;
    recalque: string;
    ns: string;
    ls: string;
    leitura_diaria?: number;
    desl_abs_x: number;
    desl_rel_x: number;
    desl_abs_y: number;
    desl_rel_y: number;
    desl_abs_z: number;
    desl_rel_z: number;
    deslocamento: number;
    npgb?: string | null; 
}

const create = async (uuid: string, data: IReading): Promise<any> => {
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post(`./leitura?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response;
        }

        throw new Error('Resposta da API não continha dados esperados.');

    } catch (error: any) {

        if (error.response && error.response.data && error.response.data.message) {
            throw new Error(error.response.data.message);
        } else if (error.message) {
            throw new Error(error.message);
        } else {
            throw new Error('Erro desconhecido ao criar leitura.');
        }
    }
};

const getAll = async (uuid: string): Promise<IReadingsInstruments[] | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./leituras/grafico?id_barragem=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response){
            if(response instanceof Error){
                return new Error('Erro ao buscar registros.');
            }else{
                return response.data;
            }
        }

        return new Error('Erro ao buscar registros.');
    }catch (error) {
        console.error(error);
        throw new Error((error as { message: string }).message || 'Erro na requisição de get gráficos.');
    }

};

const getLast = async (uuid: string): Promise<IReading[] | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./leitura?id_barragem=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response){
            if(response instanceof Error){
                return new Error('Erro ao buscar registros.');
            }else{
                return response.data;
            }
        }

        return new Error('Erro ao buscar registros.');
    }catch (error) {
        console.error(error);
        throw new Error((error as { message: string }).message || 'Erro na requisição de get gráficos.');
    }

};

function getReading(data: IReadingsInstruments[], type: string) {
    const values = data.filter(index =>
        index && index.tipo_instrumento && index.tipo_instrumento === type
    );

    // O resto da função permanece igual
    const flatData = values.flatMap(index => index.leituras);
    const allNames = flatData.map(index => index.nome);
    const names = Array.from(new Set(allNames));

    return { flatData, names };
}


export const ReadingServices = {
    create,
    getAll,
    getLast,

    getReading
};